import { useState, useEffect } from "react";
import {
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
    Button,
    Typography,
    Input,
} from "@material-tailwind/react";
import MaterialIcon from "components/material-icon";

export default function EditThemeDialog({
    open,
    onClose,
    theme, // { id, name }
    onSaveThemeName, // (id, newName) => {}
}) {
    const [themeName, setThemeName] = useState(theme?.name || "");

    useEffect(() => {
        if (open) setThemeName(theme?.name || "");
    }, [open, theme]);

    const handleClose = () => {
        onClose();
    };

    const handleClear = () => setThemeName("");

    const handleSave = () => {
        if (!themeName.trim() || themeName === theme.name) return;
        onSaveThemeName(theme.id, themeName.trim());
        handleClose();
    };

    return (
        <Dialog open={open} handler={handleClose} className="dialog">
            <DialogHeader className="dialog__header">
                <Typography variant="h4">Edit Theme Name</Typography>
            </DialogHeader>

            <DialogBody className="dialog__body">
                <div className="dialog__section flex items-center gap-2">
                    <div className="relative flex-1">
                        <Input
                            type="text"
                            label="Theme Name"
                            value={themeName}
                            onChange={(e) => setThemeName(e.target.value)}
                            placeholder={theme?.name || "Theme Name"}
                            className="font-body"
                        />
                        {themeName && (
                            <MaterialIcon
                                name="close"
                                className="absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-500"
                                onClick={handleClear}
                            />
                        )}
                    </div>
                </div>
            </DialogBody>

            <DialogFooter className="dialog__footer">
                <Button
                    type="button"
                    className="btn btn--danger"
                    onClick={handleClose}
                >
                    Cancel
                </Button>
                <Button
                    type="button"
                    className="btn btn--primary"
                    onClick={handleSave}
                    disabled={!themeName.trim() || themeName === theme.name}
                >
                    Save New Name
                </Button>
            </DialogFooter>
        </Dialog>
    );
}
